import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/softwareInt/SoftwareIntPageClient.jsx");
